import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  riskMgmtListAction,
  riskMgmtTicketListAction
} from "../../../modules/riskmanagement/action";
import "../../../style";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";
import RelatedTicketTableModal from "./RelatedTicketTableModal";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const closeButtonStyle = {
  position: "absolute",
  right: 2,
  top: 2
};

class RiskMgmtTable extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      fetchingComplete: false,
      headerRows: {
        counterpartName: "Counterpart",
        contractNumber: "Contract",
        commodityName: "Commodity",
        maturityDate: "Maturity",
        quantity: "Bushels Contracted",
        delevered: "Field Est. Load Bushels",
        balance: "Balance",
        payloadDelivered: "Net Bushels Reconciled",
        payloadBalance: "Balance after Reconciled",
        contractStage: "Stage"
      },
      order: "desc",
      orderBy: "",
      open: false,
      contractName: ""
    };
  }

  componentWillMount() {
    const {
      riskMgmtListAction,
      SubFarmId = userFarmDetail().id || this.props.MainFarmId,
      selectedYear
    } = this.props;
    if (
      !isSuperAdmin() ||
      this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      riskMgmtListAction(SubFarmId, selectedYear);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  componentWillReceiveProps(nextProps) {
    const {
      SubFarmId = userFarmDetail().id || this.props.MainFarmId
    } = this.props;
    if (
      nextProps.rowRisk &&
      this.props.rowRisk !== nextProps.rowRisk &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (
      nextProps.SubFarmId &&
      nextProps.SubFarmId !== SubFarmId &&
      nextProps.SubFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.props.riskMgmtListAction(
        nextProps.SubFarmId,
        this.props.selectedYear
      );
    }
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() ||
        nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)
    ) {
      this.props.riskMgmtListAction(SubFarmId, nextProps.selectedYear);
    }
  }

  handleClick = (id, name) => {
    const { riskMgmtTicketListAction } = this.props;
    riskMgmtTicketListAction(id);
    this.setState({
      open: true,
      contractName: name
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      contractName: ""
    });
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  render() {
    const { headerRows, order, orderBy, fetchingComplete, open } = this.state,
      { contractName } = this.state;
    const { rowRisk, ErrorMessage } = this.props;
    return (
      <div className="">
        {isSuperAdmin() &&
        this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog />
        ) : (
          <div className="RiskManagementTable">
            <Dialog
              fullWidth={true}
              maxWidth={"md"}
              open={open}
              TransitionComponent={Transition}
              onClose={this.handleClose}
            >
              <DialogTitle>
                <Typography variant="h6">
                  {`Breakdown for contract - ${contractName}`}
                </Typography>
                <IconButton
                  aria-label="Close"
                  style={closeButtonStyle}
                  onClick={this.handleClose}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent>
                <hr />
                <RelatedTicketTableModal />
              </DialogContent>
            </Dialog>
            {fetchingComplete ? (
              <CreateTable
                order={order}
                orderBy={orderBy}
                headerRows={headerRows}
                rowData={rowRisk}
                onClick={this.handleClick}
                onRequestSort={this.handleRequestSort}
                isMenuRequired={false}
                highlightPrimaryColumn={true}
                isClickable={true}
              />
            ) : (
              <Loader />
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowRisk: state.riskReducer.riskList,
    ticketList: state.riskReducer.ticketList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { riskMgmtListAction, riskMgmtTicketListAction },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RiskMgmtTable);



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement/RiskMgmtTable.js